module.exports = __webpack_public_path__ + "static/cta-moc-1-1-feb0ef1f81eceb6ba715d056f797bda0.png";